/* Siel Menu Personalize
   - 閲覧履歴：商品ページ閲覧で localStorage に保存
   - おすすめ：reco_menu タグのコレクションから常に表示
*/

(() => {
  const KEY = "siel_recent_handles_v1";
  const MAX_RECENT = 12;

  const RECO_SHOW = 6;     // おすすめ表示数
  const RECENT_SHOW = 6;   // 閲覧履歴表示数

  const moneyJPY = (cents) => {
    if (typeof cents !== "number" || !isFinite(cents)) return "";
    const yen = Math.round(cents / 100);
    return new Intl.NumberFormat("ja-JP").format(yen) + " JPY";
  };

  const escapeHTML = (s) =>
    String(s || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const readRecent = () => {
    try {
      return JSON.parse(localStorage.getItem(KEY) || "[]");
    } catch {
      return [];
    }
  };

  const writeRecent = (arr) => {
    try {
      localStorage.setItem(KEY, JSON.stringify(arr));
    } catch {}
  };

  // ① 商品ページで閲覧履歴を保存
  const saveRecentFromProductPage = () => {
    try {
      const h = window.SIEL_CURRENT_PRODUCT_HANDLE;
      if (!h) return;

      const cur = readRecent();
      const next = [h, ...cur.filter((x) => x !== h)].slice(0, MAX_RECENT);
      writeRecent(next);
    } catch {}
  };

  // /products/{handle}.js 取得
  const fetchProductJSON = async (handle) => {
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
      credentials: "same-origin",
    });
    if (!res.ok) throw new Error("product.js fetch failed");
    return await res.json();
  };

  // /collections/{handle}/products.json 取得
  const fetchCollectionProducts = async (collectionHandle, limit = 12) => {
    const res = await fetch(
      `/collections/${encodeURIComponent(collectionHandle)}/products.json?limit=${limit}`,
      { credentials: "same-origin" }
    );
    if (!res.ok) throw new Error("collection products.json fetch failed");
    const data = await res.json();
    return data?.products || [];
  };

  const normalizeCollectionProduct = (p) => {
    const img =
      (p.images && p.images.length ? p.images[0].src : "") ||
      (p.image && p.image.src ? p.image.src : "");

    const v = (p.variants && p.variants.length) ? p.variants[0] : null;
    const cents = v && typeof v.price === "string"
      ? Math.round(parseFloat(v.price) * 100)
      : 0;

    return {
      handle: p.handle,
      title: p.title,
      url: p.url || `/products/${p.handle}`,
      featured_image: img,
      price: cents,
    };
  };

  const cardHTML = (p) => {
    const img = p.featured_image ? `<img loading="lazy" src="${escapeHTML(p.featured_image)}" alt="${escapeHTML(p.title)}">` : "";
    const price = p.price ? `<div class="siel-mp__price">${escapeHTML(moneyJPY(p.price))}</div>` : "";
    return `
      <a class="siel-mp__card" href="${escapeHTML(p.url || `/products/${p.handle}`)}">
        <div class="siel-mp__img">${img}</div>
        <div class="siel-mp__name">${escapeHTML(p.title)}</div>
        ${price}
      </a>
    `;
  };

  const renderRecent = async (gridEl) => {
    const handles = readRecent().slice(0, RECENT_SHOW);
    if (!handles.length) {
      gridEl.innerHTML = `<p class="siel-mp__empty">まだ閲覧履歴がありません</p>`;
      return;
    }

    // 取得して表示（失敗したものは飛ばす）
    const items = [];
    for (const h of handles) {
      try {
        const p = await fetchProductJSON(h);
        items.push({
          handle: p.handle,
          title: p.title,
          url: `/products/${p.handle}`,
          featured_image: p.featured_image,
          price: p.price, // cents
        });
      } catch {}
      if (items.length >= RECENT_SHOW) break;
    }

    if (!items.length) {
      gridEl.innerHTML = `<p class="siel-mp__empty">まだ閲覧履歴がありません</p>`;
      return;
    }

    gridEl.innerHTML = items.map(cardHTML).join("");
  };

  // ② おすすめ：reco_menuコレクションから常に表示（閲覧履歴に依存しない）
  const renderReco = async (gridEl) => {
    const box = gridEl.closest("[data-siel-menu-personalize]");
    const collectionHandle = box?.dataset?.sielRecoCollection || "recommend"; // ← デフォルト。あとで合わせる
    try {
      const raw = await fetchCollectionProducts(collectionHandle, RECO_SHOW + 6);
      const products = raw.map(normalizeCollectionProduct);

      // 閲覧履歴の直近は除外（被り回避）
      const recent = new Set(readRecent().slice(0, 3));
      const final = [];
      for (const p of products) {
        if (!p.handle) continue;
        if (recent.has(p.handle)) continue;
        final.push(p);
        if (final.length >= RECO_SHOW) break;
      }

      if (!final.length) {
        gridEl.innerHTML = `<p class="siel-mp__empty">おすすめは準備中です</p>`;
        return;
      }
      gridEl.innerHTML = final.map(cardHTML).join("");
    } catch {
      gridEl.innerHTML = `<p class="siel-mp__empty">おすすめは準備中です</p>`;
    }
  };

  const initMenuBlocks = async () => {
    const box = document.querySelector("[data-siel-menu-personalize]");
    if (!box) return;

    const recoGrid = box.querySelector("[data-siel-reco-grid]");
    const recentGrid = box.querySelector("[data-siel-recent-grid]");

    if (recoGrid) await renderReco(recoGrid);
    if (recentGrid) await renderRecent(recentGrid);
  };

  // 商品ページに来たらまず保存
  saveRecentFromProductPage();

  // ドロワー開閉はテーマ依存なので「メニューが開かれたら描画」でなく、
  // ページロード時＆メニューを開き直した時にも反映しやすいように、
  // 少し遅延して実行 + click後にも実行しておく（軽量）
  const boot = () => initMenuBlocks();

  window.addEventListener("DOMContentLoaded", () => setTimeout(boot, 0));
  document.addEventListener("click", (e) => {
    // ハンバーガー/close周りを押したら再描画
    const t = e.target;
    if (t && (t.closest(".header__icon--menu") || t.closest("header-drawer"))) {
      setTimeout(boot, 50);
    }
  });
})();
